import _isUndefined from 'lodash/isUndefined';

export default class DocRequestParameter {
  constructor (params) {
    this.id = !_isUndefined(params.id) ? params.id : null;
  }
}
